import { render, staticRenderFns } from "./Participante.vue?vue&type=template&id=6cc8d0ca&"
import script from "./Participante.vue?vue&type=script&lang=js&"
export * from "./Participante.vue?vue&type=script&lang=js&"
import style0 from "./Participante.vue?vue&type=style&index=0&id=6cc8d0ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports